// This file was automatically generated from print.resultGrid.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.resultGrid');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.lab');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.resultGrid.resultRow = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.textReportResultValue) {
    output.append('<tr id="labResult_', soy.$$escapeHtml(opt_data.id), '"><td colspan="4" class="subSectionText"><pre>', soy.$$escapeHtml(opt_data.textReportResultValue), (opt_data.isCancelledNonPerformance) ? '*' : '', '</pre></td></tr>');
  } else if (opt_data.valueType == 'TX') {
    output.append('<tr id="labResult_', soy.$$escapeHtml(opt_data.id), '"><td colspan="3" class="itemName"><pre>', (opt_data.labTest) ? soy.$$escapeHtml(opt_data.labTest.name) : '', (opt_data.value) ? ' ' + soy.$$escapeHtml(opt_data.value) : '', (opt_data.isCancelledNonPerformance) ? '*' : '', '</pre></td><td class="w5 cell">', (opt_data.location) ? soy.$$escapeHtml(opt_data.location.labFacilityMnemonic) : '', '</td></tr>');
  } else {
    output.append('<tr id="labResult_', soy.$$escapeHtml(opt_data.id), '" class="item ', (opt_data.isStarred) ? 'starred' : '', '"><td class="w45 labTestName ', (opt_data.isStarred) ? ' starred' : '', (opt_data.isAbnormal) ? ' abnormal' : '', '">', (opt_data.labTest) ? soy.$$escapeHtml(opt_data.labTest.name) : '', '</td><td class="w15 labTestResult">', (opt_data.isAbnormal) ? '<span class="abnormal">' + ((opt_data.isCancelledNonPerformance) ? 'n/a*' : soy.$$escapeHtml(opt_data.value)) + '</span>' + ((opt_data.abnormalFlag) ? '<span class="abnormalFlag">' + soy.$$escapeHtml(opt_data.abnormalFlag) + '</span>' : '') : (opt_data.isCancelledNonPerformance) ? 'n/a*' : soy.$$escapeHtml(opt_data.value), '</td><td class="w35 labTestResult">');
    el8.template.ptdata.model.lab.reference(opt_data, output);
    output.append('</td><td class="w5 labTestResult">', (opt_data.location) ? soy.$$escapeHtml(opt_data.location.labFacilityMnemonic ? opt_data.location.labFacilityMnemonic : '') : '', '</td></tr>');
  }
  output.append((opt_data.isCancelledNonPerformance) ? '<tr><td class="itemName ml10" colspan="4"><pre>* Results cancelled due to non-performance</pre></td></tr>' : '', (opt_data.resultValueNote) ? '<tr><td class="itemName ml10 result-value-note" colspan="4"><pre>' + soy.$$escapeHtml(opt_data.resultValueNote) + '</pre></td></tr>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.resultGrid.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<table class="el8LabGrid extraSmallText avoidInnerPageBreak"><thead><tr class="el8LabHeader">', (opt_data.isTxResultOnly) ? '<td class="cell w45">&nbsp;</td>' : '<td class="cell w45">Test Name</td><td class="cell w15">Value</td><td class="cell w35">Reference Range</td><td class="cell w5">Loc</td>', '</tr></thead>');
  var categoryList17144 = opt_data.resultsByCategory;
  var categoryListLen17144 = categoryList17144.length;
  for (var categoryIndex17144 = 0; categoryIndex17144 < categoryListLen17144; categoryIndex17144++) {
    var categoryData17144 = categoryList17144[categoryIndex17144];
    output.append('<tr><td class="cell" colspan="4">', soy.$$escapeHtml(categoryData17144.label), (opt_data.status == 'PENDING') ? ' ** PENDING **' : '', '</td></tr>');
    var rowList17151 = categoryData17144.rows;
    var rowListLen17151 = rowList17151.length;
    for (var rowIndex17151 = 0; rowIndex17151 < rowListLen17151; rowIndex17151++) {
      var rowData17151 = rowList17151[rowIndex17151];
      el8.template.print.resultGrid.resultRow(rowData17151, output);
    }
  }
  output.append((opt_data.labReportNote) ? '<tr><td class="cell" colspan="4"><span class="ml10 preserve">' + soy.$$escapeHtml(opt_data.labReportNote) + '</span></td></tr>' : '', '<tfoot><tr><td colspan="4"><table class="w100"><tr><td class="w50 cell">', (opt_data.accessionNumber && ! opt_data.manualEdit) ? 'Accession No.: ' + soy.$$escapeHtml(opt_data.accessionNumber) + '<br />' : '', 'Status: ', soy.$$escapeHtml(opt_data.status), '</td><td class="w50 cell alignRight">Collected: ', (soy.$$escapeHtml(opt_data.collectedDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.collectedDate)) : ''), '<br />Completed: ', (soy.$$escapeHtml(opt_data.resultedDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.resultedDate)) : ''), '</td></tr></table></td></tr></tfoot></table>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.resultGrid.abnormalFlagLegend = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.abnormalFlags && opt_data.abnormalFlags.length && ! opt_data.lastManualEditTime) {
    output.append('<p class="extraSmallText pt5"><b>Abnormal Value Legend:</b></p>');
    var aList17179 = opt_data.abnormalFlags;
    var aListLen17179 = aList17179.length;
    for (var aIndex17179 = 0; aIndex17179 < aListLen17179; aIndex17179++) {
      var aData17179 = aList17179[aIndex17179];
      output.append('<p class="itemIndent extraSmallText">', soy.$$escapeHtml(aData17179.flag), ' = ', soy.$$escapeHtml(aData17179.description), '</p>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.resultGrid.labCenter = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="extraSmallText">', (opt_data.labFacilityMnemonic) ? ' (' + soy.$$escapeHtml(opt_data.labFacilityMnemonic) + '): ' : '', soy.$$escapeHtml(opt_data.companyName), (opt_data.companyName != opt_data.locationName) ? ' - ' + soy.$$escapeHtml(opt_data.locationName) : '', (opt_data.addressLine) ? ', ' + soy.$$escapeHtml(opt_data.addressLine) : '', (opt_data.cityStateZip) ? ', ' + soy.$$escapeHtml(opt_data.cityStateZip) : '', (opt_data.labFacilityDirector) ? ', Director: ' + soy.$$escapeHtml(opt_data.labFacilityDirector) : '', '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.resultGrid.externalReportContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<table class="el8LabGrid extraSmallText avoidInnerPageBreak"><thead><tr class="el8LabHeader"><td class="cell w45">&nbsp;</td></tr></thead><tr><td class="cell" colspan="4"></td></tr>', (opt_data.externalReportAttachment.summary) ? '<tr><td colspan="4" class="itemName ml10 result-value-note"><pre>' + soy.$$escapeHtml(opt_data.externalReportAttachment.summary) + '</pre></td><!--<td class="cell" colspan="4"><span class="ml10 preserve">' + soy.$$escapeHtml(opt_data.externalReportAttachment.summary) + '</span></td>--></tr>' : '', (opt_data.externalReportAttachment.referencedUrl) ? '<tfoot><tr><td colspan="4"><table class="w100"><tr><td class="w50 cell">' + soy.$$escapeHtml(opt_data.externalReportAttachment.referencedUrl) + '</td></tr></table></td></tr></tfoot>' : '', '</table>');
  if (!opt_sb) return output.toString();
};
